var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 237,
    height: 137,
    viewBox: "0 0 237 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236.963 136.092V-1H0.671875C1.58488 -0.673963 2.49724 -0.346635 3.40928 -0.0194168C10.6873 2.59174 17.9456 5.19583 25.3593 7.07979C38.4087 10.3596 50.9919 14.6833 63.7286 19.0597C66.3227 19.951 68.9231 20.8446 71.5352 21.7319C74.3156 22.6798 77.1213 23.5804 79.9298 24.4819C89.4007 27.5219 98.9038 30.5724 107.58 35.4805C113.17 38.6283 118.834 41.6304 124.493 44.6305C131.123 48.1446 137.748 51.6562 144.243 55.3964C145.578 56.1643 146.934 56.8796 148.299 57.5994C151.019 59.0336 153.773 60.4858 156.458 62.4082C160.025 64.9622 161.645 67.6546 163.708 71.0836C163.977 71.5308 164.254 71.9907 164.543 72.4644C170.265 81.5394 177.379 89.6226 185.614 96.4066C187.954 98.403 190.109 100.608 192.257 102.807C194.378 104.978 196.493 107.143 198.774 109.095C201.836 111.782 205.011 114.349 208.188 116.918C211.558 119.642 214.929 122.368 218.167 125.239C221.332 128.038 228.568 131.894 236.963 136.092Z",
    fill: "#414141"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorner);
export default __webpack_public_path__ + "static/media/corner.20b0301979d77f3272d66b0f1011d44b.svg";
export { ForwardRef as ReactComponent };